import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  .uploadcare--dialog__panel {
    background-color: var(--color-bg-surface-floating);
    box-shadow: var(--shadow-dialog);
    color: var(--color-text-neutral);
    border-radius: var(--border-radius-md);
  }

  .uploadcare--menu { display: none; }
  .uploadcare--powered-by { display: none; }

  .uploadcare--panel__footer {
    background-color: var(--color-bg-surface-floating);
  }

  .uploadcare--button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--color-border-subtle);
    background: transparent;
    color: var(--color-text-neutral);
    font-family: var(--font-family-body);
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-body);
    padding: 0 var(--space-sm);
    cursor: pointer;
    user-select: none;
    transition-property: border-color, background, color;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }

  .uploadcare--button:hover,
  .uploadcare--button:focus,
  .uploadcare--button:active {
    border-color: var(--color-border-neutral);
    background: var(--color-bg-subtle);
    color: var(--color-text-neutral);
  }

  .uploadcare--button:focus {
    outline: 2px solid var(--focus-color);
    outline-offset: 1px;
  }

  .vrLight .uploadcare--button,
  .vrDark .uploadcare--button {
    border-radius: var(--border-radius-full);
  }

  .uploadcare--button_primary {
    background: var(--color-bg-brand);
    border-color: var(--color-bg-brand);
    color: var(--color-text-inverted);
    border-radius: var(--border-radius-sm);
    font-family: var(--font-family-body);
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-body);
    padding: 0 var(--space-sm);
    height: var(--control-size-md);
    cursor: pointer;
    user-select: none;
    transition-property: border-color, background, color;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }

  .vrLight .uploadcare--button_primary,
  .vrDark .uploadcare--button_primary {
    border-radius: var(--border-radius-full);
    color: var(--color-text-on-light);
  }

  .uploadcare--button_primary:hover,
  .uploadcare--button_primary:focus,
  .uploadcare--button_primary:active {
    font-family: var(--font-family-body);
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-body);
    background: var(--color-bg-brand-strong);
    border-color: var(--color-bg-brand-strong);
  }

  .uploadcare-tab-effects--cancel { visibility: hidden; }

  .uploadcare--dialog__close {
    cursor: pointer;
    user-select: none;
    transition-property: border-color, background, color;
    transition-duration: 0.15s;
    transition-timing-function: ease;
    width: var(--control-size-md);
    height: var(--control-size-md);
    padding: 0;
  }

  .vrLight .uploadcare--dialog__close,
  .vrDark .uploadcare--dialog__close {
    border-radius: var(--border-radius-full);
  }

  .uploadcare--button_muted:hover,
  .uploadcare--button_muted:focus,
  .uploadcare--button:active {
    color: var(--color-text-brand);
  }

  .uploadcare-tab-effects--effect-button {
    color: var(--color-text-neutral);
    fill: var(--color-text-neutral);
    border: none;
    background: none;
  }

  .uploadcare-tab-effects--effect-button:hover,
  .uploadcare-tab-effects--effect-button:active,
  .uploadcare-tab-effects--effect-button:focus {
    color: var(--color-bg-brand-strong);
    fill: var(--color-bg-brand-strong);
    background: none;
  }

  input[type=range].uploadcare-tab-effects--range__input {
    accent-color: var(--color-bg-brand);
  }

  .uploadcare--crop-sizes__item[data-caption="540:283"]::after { content: '1.91:1'; }
  .uploadcare-tab-effects--effect-button_applied:before {
      background: var(--color-bg-brand-strong);
  }
  .uploadcare--crop-sizes__item_current:before {
    background: var(--color-bg-brand-strong);
  }
  .uploadcare-tab-effects--crops  {
    gap: var(--space-sm);

    .uploadcare--crop-sizes__item {
      height: unset;
      border: none;
      border-radius: var(--border-radius-sm);
    }
  }
  
`

export default GlobalStyles
